import {Client} from "../../../domain/model/client";
import {Customer} from "../../../domain/model/customer";
import {MessageState, Role} from "../../../domain/model/user";
import {api, entity} from "../rpc/api";
import {ClientConvertResponse} from "./client_api_convert";
import {CustomerConvertResponse} from "./customer_api_convert";
import MessageStateResponse = api.Me.MessageState;

class UserConvertResponse {
    public static from(from: api.Me): UserConvertResponse {
        let client: Client | null = null;
        let customer: Customer | null = null;

        if (from.client) {
            const client_response: entity.Client = from.client as entity.Client;
            client = Client.from(ClientConvertResponse.from(client_response));
        }

        if (from.customer) {
            const customer_response: entity.Customer =
                from.customer as entity.Customer;
            customer = Customer.from(CustomerConvertResponse.from(customer_response));
        }

        const messageStateList = from.messageStateList.map(
            (item: MessageStateResponse) => {
                return new MessageState(item.roomID, item.isUnRead, item.unReadCount);
            }
        );

        return new UserConvertResponse(
            from.email,
            from.role,
            client,
            customer,
            messageStateList,
            from.shouldUpdateCompany
        );
    }

    constructor(
        public readonly email: string,
        public readonly role: Role,
        public readonly client: Client | null,
        public readonly customer: Customer | null,
        public readonly messageStateList: MessageState[],
        public readonly shouldUpdateCompany: boolean
    ) {
    }
}

export {UserConvertResponse};



// WEBPACK FOOTER //
// ./src/infra/api/service/user_api_convert.ts